import { useState, useEffect, useCallback } from 'react'
import { useNavigate, useLocation, Link } from 'react-router-dom'
// ------ Services ------ //
import * as leadCaptureService from '../../../services/leadCaptureService'
// ------ Styles ------ //
import styles from "./LeadCaptureList.module.css"
// ------ Components ------ //
import LCEvent from "../../../components/LeadCapture/LeadCaptureList/LCEvent"
import LoadingSpinner from '../../../components/Miscellaneous/LoadingSpinner'
import HoverButton from '../../../components/Miscellaneous/HoverButton'

const LeadCaptureList = ({ user }) => {
    const [leadCaptures, setLeadCaptures] = useState([])
    const [loaded, setLoaded] = useState(false)
    const [message, setMessage] = useState([''])
    const navigate = useNavigate()
    const [formData, setFormData] = useState(
        {
            id: null,
            futureOnly: true,
            includeTests: false
        }
    )
    const createRequestBody = async () => {

        let requestBody = {}

        requestBody =
        {
            "futureOnly": `${formData.futureOnly}`,
            "includeTests": `${formData.includeTests}`
        }

        return await requestBody;
    }
    const handleChange = (e) => {
        if (e.target.type === 'checkbox') {
            setFormData({
                ...formData,
                [e.target.name]: e.target.checked,
            })
        }
        else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value,
            })
        }
    }
    const handleSubmit = async e => {
        e.preventDefault()
        try {
            fetchData()
        } catch (err) {
            setMessage(err.message)
        }

    }
    const editEvent = async e => {
        e.preventDefault()
        let divId = e.currentTarget.id
        //if (!divId) {
        //    e.current.id
        //}
        try {
            navigate(`/LeadCaptureConfig/${divId}`);
        } catch (err) {
            setMessage(err.message)
        }
    }
    const fetchData = async () => {
        if (loaded === false) {
            const getReqBody = await createRequestBody()
            try {
                const LCEvents = await leadCaptureService.getEvents(getReqBody)
                if (LCEvents && LCEvents.length > 0) {
                    setLeadCaptures(LCEvents)
                }
                else {
                    setLeadCaptures([])
                }
            } catch (err) {
                setMessage(err.message)
                setLeadCaptures([])
            }

            setLoaded(true)
        }
        
    }
    useEffect(() => {
        
        fetchData()
    },[])
   
    return (
        <div className="page-area">
            <h1>Lead Capture Events</h1><br /><br />
            <h4>List of all lead capture events - by default, future only.<br /><br />Configure and add as necessary.</h4>
            {loaded ?
                <>
                    <form onSubmit={handleSubmit}>
                        <div className={styles.wrapper}>
                            <div className={styles.left}>
                                <div className={styles.inputContainer}>
                                    <label className={styles.label} title="True - only display future events.">
                                        Future Events Only: <input
                                            type="checkbox"
                                            autoComplete="off"
                                            checked={formData.futureOnly ? true : false}
                                            name="futureOnly"
                                            onChange={handleChange}
                                            style={{
                                                width: '10%',
                                            }}
                                        />

                                    </label>

                                </div>
                            </div>
                        </div>
                        <div className={styles.wrapper}>
                            <div className={styles.left}>
                                <div className={styles.inputContainer}>
                                    <label className={styles.label} title="True - include test events.">
                                        Include Test Events: <input
                                            type="checkbox"
                                            autoComplete="off"
                                            checked={formData.includeTests ? true : false}
                                            name="includeTests"
                                            onChange={handleChange}
                                            style={{
                                                width: '10%',
                                            }}
                                        />

                                    </label>
                                </div>
                            </div>
                        </div>

                    </form>
                    <Link to={`/LeadCaptureConfig`} className={styles.eventLinks} title="Create new Lead Capture Event.">
                        <h3>Create New Lead Capture Event</h3>
                    </Link>
                    <div className={styles.containerEvents}>
                        {leadCaptures && leadCaptures.length ?
                            <div className={styles.tableEventsContainer}>
                                <table className={styles.tableEvents}>
                                    <thead>
                                        <tr className={styles.trEvents}>
                                        
                                            <th className={styles.thEvents}>
                                                Reference Number
                                                <HoverButton
                                                    title={'Reference number for direct navigation.'}
                                                    messageWidth={75}
                                                />
                                            </th>
                                            <th className={styles.thEvents}>
                                                Lead Capture Event Name
                                                <HoverButton
                                                    title={'Lead capture event name.'}
                                                    messageWidth={75}
                                                />
                                            </th>
                                            <th className={styles.thEvents}>
                                                Client Name
                                                <HoverButton
                                                    title={'Client name associated with lead capture event.'}
                                                    messageWidth={75}
                                                />
                                            </th>
                                            <th className={styles.thEvents}>
                                                Event Name
                                                <HoverButton
                                                    title={'Event associated with lead capture event.'}
                                                    messageWidth={75}
                                                />
                                            </th>
                                            <th className={styles.thEvents}>
                                                Event Name 2
                                                <HoverButton
                                                    title={'Second event associated with lead capture event.'}
                                                    messageWidth={75}
                                                />
                                            </th>
                                            <th className={styles.thEvents}>
                                                Event Name 3
                                                <HoverButton
                                                    title={'Third event associated with lead capture event.'}
                                                    messageWidth={75}
                                                />
                                            </th>
                                            <th className={styles.thEvents}>
                                                Event Name 4
                                                <HoverButton
                                                    title={'Fourth event associated with lead capture event.'}
                                                    messageWidth={75}
                                                />
                                            </th>
                                            <th className={styles.thEvents}>
                                                Early Registration Deadline
                                                <HoverButton
                                                    title={'Date when early registration pricing ends.'}
                                                    messageWidth={75}
                                                />
                                            </th>
                                            <th className={styles.thEvents}>
                                                Event Start Date
                                                <HoverButton
                                                    title={'Date when lead capture event begins.'}
                                                    messageWidth={75}
                                                />
                                            </th>
                                            <th className={styles.thEvents}>
                                                Test Event
                                                <HoverButton
                                                    title={'Flag for test event.'}
                                                    messageWidth={75}
                                                />
                                            </th>
                                            <th className={styles.thEvents}>User Actions<HoverButton
                                                title={'Extra options.'}
                                                messageWidth={75}
                                            /></th>
                                        </tr>
                                    </thead>
                                    <tbody key={leadCaptures.length}>
                                        {leadCaptures.map((item, index) => (
                                            <LCEvent
                                                eventItem={item}
                                                editEvent={editEvent}
                                                key={index}
                                            ></LCEvent>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            :
                            <div>
                                <div className={styles.errorEventsMessage}> No lead capture events configured!</div>
                            </div>
                        }
                    </div>
                    <br /><br />
                    <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
                </>
                :
                <LoadingSpinner />
            }
        </div>
    );
}

export default LeadCaptureList;